import {
  convertArrayBufferToBase64String,
  convertBase64StringToArrayBuffer,
} from "../util/Utility";
import { SignatureMetadata } from "./SignatureMetadata_types";
import { TFramedTransport, TBinaryProtocol } from "thrift";

/**
 * Serializes native data of given model into Thrift.
 *
 * @param data Data to serialize.
 */
export const serializeThrift = data => {
  var transport = new TFramedTransport(null);
  var binaryProt = new TBinaryProtocol(transport);
  data.write(binaryProt);

  // copy array of array into byteArray
  let source = transport.outBuffers;
  var byteArrayLen = 0;
  for (var i = 0, len = source.length; i < len; i++)
    byteArrayLen += source[i].length;
  let byteArray = new Buffer.alloc(byteArrayLen);
  for (var i = 0, len = source.length, pos = 0; i < len; i++) {
    let chunk = source[i];
    chunk.copy(byteArray, pos);
    pos += chunk.length;
  }
  return convertArrayBufferToBase64String(byteArray);
};

/**
 * Deserializes Thrift data with given model.
 *
 * @param thriftString Thrift data as a string.
 */
export const deserializeThrift = (thriftString, object) => {
  const inputAsByteArray = new Uint8Array(
    convertBase64StringToArrayBuffer(thriftString)
  );

  let data = new Buffer.alloc(inputAsByteArray.length);
  for (var i = 0, len = inputAsByteArray.length, pos = 0; i < len; i++) {
    let chunk = inputAsByteArray[i];
    data[pos] = chunk;
    pos++;
  }

  var thisTransport = new TFramedTransport(data);
  var protocol = new TBinaryProtocol(thisTransport);

  object.read(protocol);
  protocol.flush();

  return object;
};
